import fetch from 'fetch-retry'
import { observable, flow } from 'mobx'
const autUri = process.env.REACT_APP_AUTH_BASE_URI
class UserStore {
  @observable profile = null
  @observable loading = true
  getProfile = flow(function * () {
    const response = yield fetch(`${autUri}/user`, {
      credentials: 'include'
    })

    if (response.ok) {
      const profile = yield response.json()
      // const { user_name: [userId], param: [jsonParams], userRole: [userRole] } = data.claims
      // const profile = yield response.json()
      // const params = JSON.parse(jsonParams)
      this.loading = false
      this.profile = profile
    } else {
      this.loading = false
    }
  })
}

const userStore = new UserStore()

export default userStore



// WEBPACK FOOTER //
// ./src/stores/user.js